import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../../models/hooks/appStateHooks';

interface IDomainNameResponse {
	name?: string;
	status?: string;
}

export function useRequestEmailDomain({
	impersonationContext,
	onError,
	onSuccess,
}: {
	impersonationContext: Api.IImpersonationContext;
	onError?: (error: Api.IOperationResultNoValue) => void;
	onSuccess?: (data: IDomainNameResponse) => void;
}) {
	const userSession = useUserSession();
	return useMutation({
		mutationFn: ({ domainName }: { domainName: string }) => {
			return userSession.webServiceHelper.callAsync<IDomainNameResponse>(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					urlPath: `domainName/registerDomain/email`,
					queryParams: {
						domainName,
					},
				}),
				'POST',
				null
			);
		},
		onError,
		onSuccess,
	});
}
